function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.958 21.421a1.547 1.547 0 01-1.16-.541L.258 3.323a1.547 1.547 0 012.4-1.934l13.3 16.088L29.88.696a1.547 1.547 0 112.4 1.934L17.119 20.802a1.47 1.47 0 01-1.16.619z",
  fill: "currentColor"
});

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.717 21.421"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMi43MTcgMjEuNDIxIj4KICA8cGF0aCBkPSJNMTUuOTU4IDIxLjQyMWExLjU0NyAxLjU0NyAwIDAxLTEuMTYtLjU0MUwuMjU4IDMuMzIzYTEuNTQ3IDEuNTQ3IDAgMDEyLjQtMS45MzRsMTMuMyAxNi4wODhMMjkuODguNjk2YTEuNTQ3IDEuNTQ3IDAgMTEyLjQgMS45MzRMMTcuMTE5IDIwLjgwMmExLjQ3IDEuNDcgMCAwMS0xLjE2LjYxOXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4=";
export { SvgChevronDown as ReactComponent };